import { useAsertoApiWithAuth0Token, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useConsoleBackendClient() {
  const { backendServiceUrl } = useConfig()
  return useAsertoApiWithAuth0Token(v1Api(backendServiceUrl))
}
